import { useTranslation } from 'react-i18next'
import { QuickGlanceOverlay } from '@fs/zion-ui'
import React from 'react'
import PersonChangesLabelAndData from './PersonChangesLabelAndData'
import { enumToCamelCase } from '../../../util/StringUtil'

export default function PersonChangesMoreMetadataDialog({ metadata, idsMetadata, ...overlay }) {
  const { t } = useTranslation()
  return (
    <QuickGlanceOverlay {...overlay}>
      {metadata.op && (
        <PersonChangesLabelAndData
          label={t('person.overlay.operation', 'Operation')}
          data={t(`person.changes.${metadata.op}`, enumToCamelCase(metadata.op))}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.changeId && (
        <PersonChangesLabelAndData
          label={t('person.overlay.changeId', 'Change ID')}
          data={metadata.changeId}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.targetEntityId && (
        <PersonChangesLabelAndData
          label={(t('person.overlay.targetEntityId'), 'Target Entity ID')}
          data={metadata.targetEntityId}
          idsMetadata={idsMetadata}
        />
      )}
      {metadata.targetEntityType && (
        <PersonChangesLabelAndData
          label={t('person.overlay.targetEntityType', 'Target Entity Type')}
          data={metadata.targetEntityType}
          idsMetadata={idsMetadata}
        />
      )}
    </QuickGlanceOverlay>
  )
}
